/* src/app/common/mpos-forms/components/mpos-dual-list/mpos-dual-list.component.scss */
:host {
  display: flex;
  flex: 1 1 0%;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL2FwcC9jb21tb24vbXBvcy1mb3Jtcy9jb21wb25lbnRzL21wb3MtZHVhbC1saXN0L21wb3MtZHVhbC1saXN0LmNvbXBvbmVudC5zY3NzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyI6aG9zdCB7XG4gICAgLy8gd2lkdGg6IDEwMCVcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXg6IDEgMSAwJTtcbiAgICAvLyB3aWR0aDogMTAwJTtcbn1cbiJdLAogICJtYXBwaW5ncyI6ICI7QUFBQTtBQUVJLFdBQUE7QUFDQSxRQUFBLEVBQUEsRUFBQTs7IiwKICAibmFtZXMiOiBbXQp9Cg== */
